import api, { BaseAPIClass } from './api';


class PesquisaPrecoAPI extends BaseAPIClass{
    constructor() {
        super('/pesquisa_preco/pesquisa_preco/');
      }     

    template = async () => {
      return api.get(this.path + 'template/', { responseType: 'blob' });
    }

    importar = async (file) => {
      const formData = new FormData();
      formData.append('xls', file);
      return api.post(this.path + 'importar/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    }
}


export default new PesquisaPrecoAPI();
